import { combineReducers } from "redux";

import store from "./Store/Reducer";
import menu from "./Menu/Reducer";
import dialogs from "./Dialogs/Reducer";
import user from "./User/Reducer";

export default combineReducers({
  store,
  menu,
  dialogs,
  user,
});
